import React, { useState } from "react";
import fgLogo from "../../img/fg-logo-p.png";
import mistral_logo from "../../img/mistral_logo.PNG"
import { useHistory } from "react-router";
import FeedbackForm from "./FeedbackForm";
import { useSelector, useDispatch } from "react-redux";
import { clearReportState } from "../../actions/reports";

const Header = ({ isHeader = false }) => {
  const [showList, setShowList] = useState(false);
  const [isShowFeedback, setIsShowFeedback] = useState(false);
  const profile = useSelector((state) => state.profileReducer);
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickHandler = (type = "") => {
    dispatch(clearReportState());
    history.push(`/FaultReporter/admin/${type}`);
  };
  const userData = useSelector((state) => state.usersReducers);

  const openCloseModal = (status) => {
    setIsShowFeedback(status);
  };

  const redirectHandler = () => {
    dispatch(clearReportState());
    if (history) history.push(`/FaultReporter/admin/customerfacilityfault`);
  };

  if (isHeader) {
    return (
      <header id="header">
        <ul className="header-inner ">
          <li className="logo" onClick={redirectHandler}>
            <div className="logoImage"></div>Fault Reporter
          </li>
        </ul>
      </header>
    );
  }
  return (
    <>
      <header id="header">
        <ul className="header-inner ">
          <li className="logo" onClick={redirectHandler}>
            <div className="logoImage"></div>Fault Reporter
          </li>
          <li
            className={`dropdown pull-right ${showList ? "active" : ""}`}
            onClick={() => setShowList(!showList)}
          >
            <i className="tm-icon zmdi zmdi-more-vert"></i>
            {showList ? (
              <ul className="dropdownOptions Menu">
                  {(userData.isAuthorized && (userData.roleID === 3 ||
                    userData.roleID === 4 ||
                    userData.roleID === 5)) && (
                    <>
                      <li
                        className="hidden-xs"
                        onClick={() => onClickHandler("manage/user/list/data")}
                      >
                        <i className="zmdi zmdi-account" style={{marginRight:"5px"}} ></i>  User Management
                      </li>
                      <li
                        onClick={() => onClickHandler("customerfacilityfault")}
                        
                      >
                        <i className="cfacility-fault-icon" ></i>Customer Station
                        Faults
                      </li>
                      <li onClick={() => onClickHandler("customertrainfault")}>
                        <i className="ctrain-fault-icon"></i> Customer Train
                        Faults
                      </li>
                      <li
                        onClick={() => setIsShowFeedback(true)}
                        data-bs-target="#feedbackModal"
                        data-bs-toggle="modal"
                      >
                        <i className="zmdi zmdi-comments" style={{marginRight:"9px"}} ></i>Feedback
                      </li>
                    </>
                  )}
                <li data-bs-target="#aboutUsModal" data-bs-toggle="modal">
                  <i className="abouticon"></i>About
                </li>
              </ul>
            ) : null}
          </li>
          <li className="pull-right welcometext pr-10">
            <small>Welcome</small>
            <h2>{profile && profile.fullname}</h2>
          </li>
        </ul>
      </header>
      {isShowFeedback && <FeedbackForm openCloseModal={openCloseModal} />}
      <div
        className="modal fade"
        id="aboutUsModal"
        tabIndex="-1"
        aria-labelledby="aboutModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="aboutModalLabel">
                About
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body text-center p-b-30">
              {/* <img className="logo-img" src={mistral_logo} alt="img" /> */}
              <p>
                Fault Reporter V {userData.version} has been developed by
                Mistral Data.
              </p>
            </div>
          </div>
        </div>
      </div>
      {showList && (
        <div className="Invisible" onClick={() => setShowList(false)}></div>
      )}
    </>
  );
};

export default Header;
